import { useEffect } from 'react'
import i18n from 'i18n'
import { DEFAULT_LOCALE } from 'civic-champs-translations/src'
import { useInternationalizationEnabled } from '../feature'
import OrgAdminLocaleSync from './OrgAdminLocaleSync'

/** Keeps locale at English and disables org locale sync when product switch is off. */
const InternationalizationBootstrap = () => {
  const enabled = useInternationalizationEnabled()

  useEffect(() => {
    if (!enabled && i18n.language.split('-')[0] !== DEFAULT_LOCALE) {
      void i18n.changeLanguage(DEFAULT_LOCALE)
    }
  }, [enabled])

  if (!enabled) {
    return null
  }

  return <OrgAdminLocaleSync />
}

export default InternationalizationBootstrap
